import { render, staticRenderFns } from "./CarrierOrders.vue?vue&type=template&id=8fab9796&scoped=true&"
import script from "./CarrierOrders.vue?vue&type=script&lang=js&"
export * from "./CarrierOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fab9796",
  null
  
)

export default component.exports